import React from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import Barcode from 'react-barcode'

export default function AppointmentBarcodeModal({ visible, onClose, appointment }) {
    return (
        <React.Fragment>
            <Modal isOpen={visible} toggle={onClose}>
                <ModalHeader toggle={onClose}>
                    Cita #0{appointment.id}
                </ModalHeader>
                <ModalBody>
                    <p className='text-center mb-10'>
                        <em className='text-muted'>Muestre este código de barras a la persona que entrega el insumo.</em>
                    </p>
                    <div className='text-center mb-20'>
                        <Barcode 
                            value={appointment.id} 
                            width={5}
                            height={70}
                            background="#fff"
                            fontSize={12}
                            fontOptions="bold"
                            fontStyle="normal"
                            fontWeight="normal"
                        />
                    </div>
                    <div>
                        <p className='mb-0'><strong>Orden de compra: </strong>{appointment.order.sku}</p>
                        <p className='mb-0'><strong>Bodega: </strong>{appointment.warehouse.sku}</p>
                        <p className='mb-0'><strong>Fecha de la cita: </strong>{appointment.start_at}</p>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}